"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeValetFee = changeValetFee;
exports.currentPriceTableFee = currentPriceTableFee;
exports.currentValetFee = currentValetFee;
exports.editValet = editValet;
exports.exportCustomersReportCSV = exportCustomersReportCSV;
exports.exportCustomersReportPDF = exportCustomersReportPDF;
exports.getValetById = getValetById;
exports.listCustomersReport = listCustomersReport;
exports.listPastValets = listPastValets;
exports.listPaymentMethodsFilters = listPaymentMethodsFilters;
exports.listSortByFilters = listSortByFilters;
exports.listValets = listValets;
exports.valetAbility = valetAbility;
exports.valetAllowCheckout = valetAllowCheckout;
exports.valetMovementByDay = valetMovementByDay;
exports.valetPaymentSummary = valetPaymentSummary;
exports.valetUsageByPeriods = valetUsageByPeriods;
exports.valetWatcher = valetWatcher;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _variables = require("../../Notification/variables");
var _utils = require("../../../utils");
var _variables2 = require("../variables");
var _helpers = require("@qwkin/helpers");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(valetWatcher);
function listValets(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.ValetService.listValets, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables2.LIST_VALETS_SUCCESS,
            payload: response
          });
        case 6:
          _context.next = 16;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 13;
          return (0, _effects.put)({
            type: _variables2.LIST_VALETS_FAIL,
            payload: _response
          });
        case 13:
          _context.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 15:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  })();
}
function valetPaymentSummary(_ref3) {
  var payload = _ref3.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.ValetService.valetPaymentSummary, payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables2.VALET_PAYMENT_SUMMARY_SUCCESS,
            payload: response
          });
        case 6:
          _context2.next = 16;
          break;
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 13;
          return (0, _effects.put)({
            type: _variables2.VALET_PAYMENT_SUMMARY_FAIL,
            payload: _response2
          });
        case 13:
          _context2.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 15:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 8]]);
  })();
}
function valetAbility(_ref5) {
  var payload = _ref5.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.ValetService.valetAbility, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables2.VALET_ABILITY_SUCCESS,
            payload: response
          });
        case 6:
          _context3.next = 16;
          break;
        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 13;
          return (0, _effects.put)({
            type: _variables2.VALET_ABILITY_FAIL,
            payload: _response3
          });
        case 13:
          _context3.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 15:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 16:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 8]]);
  })();
}
function currentValetFee(_ref7) {
  var payload = _ref7.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.ValetService.currentValetFee, payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables2.CURRENT_VALET_FEE_SUCCESS,
            payload: response
          });
        case 6:
          _context4.next = 16;
          break;
        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](0);
          _response4 = _context4.t0.response;
          _context4.next = 13;
          return (0, _effects.put)({
            type: _variables2.CURRENT_VALET_FEE_FAIL,
            payload: _response4
          });
        case 13:
          _context4.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 15:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 16:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 8]]);
  })();
}
function valetAllowCheckout(_ref9) {
  var payload = _ref9.payload,
    _ref9$callback = _ref9.callback,
    callback = _ref9$callback === void 0 ? _helpers.identity : _ref9$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var response, _response5$data, _response5$data2, _response5;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.ValetService.valetAllowCheckout, payload);
        case 3:
          response = _context5.sent;
          _context5.next = 6;
          return (0, _effects.put)({
            type: _variables2.VALET_ALLOW_CHECKOUT_SUCCESS,
            payload: response
          });
        case 6:
          _context5.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Allow Checkout done successfully'
            }
          });
        case 8:
          callback();
          _context5.next = 19;
          break;
        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](0);
          _response5 = _context5.t0.response;
          _context5.next = 16;
          return (0, _effects.put)({
            type: _variables2.VALET_ALLOW_CHECKOUT_FAIL,
            payload: _response5
          });
        case 16:
          _context5.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response5$data = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data !== void 0 ? _response5$data : {}),
              data: _response5
            }
          });
        case 18:
          (0, _utils.logErr)((_response5$data2 = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data2 !== void 0 ? _response5$data2 : {});
        case 19:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 11]]);
  })();
}
function listPastValets(_ref11) {
  var payload = _ref11.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var response, _response6$data, _response6$data2, _response6;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.ValetService.listValets, payload);
        case 3:
          response = _context6.sent;
          _context6.next = 6;
          return (0, _effects.put)({
            type: _variables2.LIST_PAST_VALETS_SUCCESS,
            payload: response
          });
        case 6:
          _context6.next = 16;
          break;
        case 8:
          _context6.prev = 8;
          _context6.t0 = _context6["catch"](0);
          _response6 = _context6.t0.response;
          _context6.next = 13;
          return (0, _effects.put)({
            type: _variables2.LIST_PAST_VALETS_FAIL,
            payload: _response6
          });
        case 13:
          _context6.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response6$data = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data !== void 0 ? _response6$data : {}),
              data: _response6
            }
          });
        case 15:
          (0, _utils.logErr)((_response6$data2 = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data2 !== void 0 ? _response6$data2 : {});
        case 16:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 8]]);
  })();
}
function listCustomersReport(_ref13) {
  var payload = _ref13.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
    var response, _response7$data, _response7$data2, _response7;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_services.ValetService.valetCustomersReport, payload);
        case 3:
          response = _context7.sent;
          _context7.next = 6;
          return (0, _effects.put)({
            type: _variables2.VALET_CUSTOMERS_REPORT_SUCCESS,
            payload: response
          });
        case 6:
          _context7.next = 16;
          break;
        case 8:
          _context7.prev = 8;
          _context7.t0 = _context7["catch"](0);
          _response7 = _context7.t0.response;
          _context7.next = 13;
          return (0, _effects.put)({
            type: _variables2.VALET_CUSTOMERS_REPORT_FAIL,
            payload: _response7
          });
        case 13:
          _context7.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response7$data = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data !== void 0 ? _response7$data : {}),
              data: _response7
            }
          });
        case 15:
          (0, _utils.logErr)((_response7$data2 = _response7 === null || _response7 === void 0 ? void 0 : _response7.data) !== null && _response7$data2 !== void 0 ? _response7$data2 : {});
        case 16:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 8]]);
  })();
}
function listPaymentMethodsFilters(_ref15) {
  var payload = _ref15.payload,
    _ref15$callback = _ref15.callback,
    callback = _ref15$callback === void 0 ? _helpers.identity : _ref15$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
    var _response$data3, response, _response8$data, _response8$data2, _response8;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_services.ValetService.listCustomerReportsPaymentoMethodFilters, payload);
        case 3:
          response = _context8.sent;
          _context8.next = 6;
          return (0, _effects.put)({
            type: _variables2.LIST_PAYMENT_METHOD_FILTERS_SUCCESS,
            payload: response
          });
        case 6:
          callback((_response$data3 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data3 !== void 0 ? _response$data3 : []);
          _context8.next = 17;
          break;
        case 9:
          _context8.prev = 9;
          _context8.t0 = _context8["catch"](0);
          _response8 = _context8.t0.response;
          _context8.next = 14;
          return (0, _effects.put)({
            type: _variables2.LIST_PAYMENT_METHOD_FILTERS_FAIL,
            payload: _response8
          });
        case 14:
          _context8.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response8$data = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data !== void 0 ? _response8$data : {}),
              data: _response8
            }
          });
        case 16:
          (0, _utils.logErr)((_response8$data2 = _response8 === null || _response8 === void 0 ? void 0 : _response8.data) !== null && _response8$data2 !== void 0 ? _response8$data2 : {});
        case 17:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 9]]);
  })();
}
function listSortByFilters(_ref17) {
  var payload = _ref17.payload,
    _ref17$callback = _ref17.callback,
    callback = _ref17$callback === void 0 ? _helpers.identity : _ref17$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
    var _response$data4, response, _response9$data, _response9$data2, _response9;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(_services.ValetService.listCustomerReportsSortByFilters, payload);
        case 3:
          response = _context9.sent;
          _context9.next = 6;
          return (0, _effects.put)({
            type: _variables2.LIST_SORT_BY_FILTERS_SUCCESS,
            payload: response
          });
        case 6:
          callback((_response$data4 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data4 !== void 0 ? _response$data4 : []);
          _context9.next = 17;
          break;
        case 9:
          _context9.prev = 9;
          _context9.t0 = _context9["catch"](0);
          _response9 = _context9.t0.response;
          _context9.next = 14;
          return (0, _effects.put)({
            type: _variables2.LIST_SORT_BY_FILTERS_FAIL,
            payload: _response9
          });
        case 14:
          _context9.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response9$data = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data !== void 0 ? _response9$data : {}),
              data: _response9
            }
          });
        case 16:
          (0, _utils.logErr)((_response9$data2 = _response9 === null || _response9 === void 0 ? void 0 : _response9.data) !== null && _response9$data2 !== void 0 ? _response9$data2 : {});
        case 17:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 9]]);
  })();
}
function exportCustomersReportPDF(_ref19) {
  var payload = _ref19.payload,
    _ref19$callback = _ref19.callback,
    callback = _ref19$callback === void 0 ? report : _ref19$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
    var _response$data5, response, _response10$data, _response10$data2, _response10;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.call)(_services.ValetService.exportCustomersReportPDF, payload);
        case 3:
          response = _context10.sent;
          _context10.next = 6;
          return (0, _effects.put)({
            type: _variables2.EXPORT_CUSTOMERS_REPORT_PDF_SUCCESS,
            payload: response
          });
        case 6:
          callback((_response$data5 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data5 !== void 0 ? _response$data5 : []);
          _context10.next = 17;
          break;
        case 9:
          _context10.prev = 9;
          _context10.t0 = _context10["catch"](0);
          _response10 = _context10.t0.response;
          _context10.next = 14;
          return (0, _effects.put)({
            type: _variables2.EXPORT_CUSTOMERS_REPORT_PDF_FAIL,
            payload: _response10
          });
        case 14:
          _context10.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response10$data = _response10 === null || _response10 === void 0 ? void 0 : _response10.data) !== null && _response10$data !== void 0 ? _response10$data : {}),
              data: _response10
            }
          });
        case 16:
          (0, _utils.logErr)((_response10$data2 = _response10 === null || _response10 === void 0 ? void 0 : _response10.data) !== null && _response10$data2 !== void 0 ? _response10$data2 : {});
        case 17:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 9]]);
  })();
}
function exportCustomersReportCSV(_ref21) {
  var payload = _ref21.payload,
    _ref21$callback = _ref21.callback,
    callback = _ref21$callback === void 0 ? report : _ref21$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
    var _response$data6, response, _response11$data, _response11$data2, _response11;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _context11.next = 3;
          return (0, _effects.call)(_services.ValetService.exportCustomersReportCSV, payload);
        case 3:
          response = _context11.sent;
          _context11.next = 6;
          return (0, _effects.put)({
            type: _variables2.EXPORT_CUSTOMERS_REPORT_CSV_SUCCESS,
            payload: response
          });
        case 6:
          callback((_response$data6 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data6 !== void 0 ? _response$data6 : []);
          _context11.next = 17;
          break;
        case 9:
          _context11.prev = 9;
          _context11.t0 = _context11["catch"](0);
          _response11 = _context11.t0.response;
          _context11.next = 14;
          return (0, _effects.put)({
            type: _variables2.EXPORT_CUSTOMERS_REPORT_CSV_FAIL,
            payload: _response11
          });
        case 14:
          _context11.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response11$data = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data !== void 0 ? _response11$data : {}),
              data: _response11
            }
          });
        case 16:
          (0, _utils.logErr)((_response11$data2 = _response11 === null || _response11 === void 0 ? void 0 : _response11.data) !== null && _response11$data2 !== void 0 ? _response11$data2 : {});
        case 17:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[0, 9]]);
  })();
}
function changeValetFee(_ref23) {
  var payload = _ref23.payload,
    _ref23$callback = _ref23.callback,
    callback = _ref23$callback === void 0 ? _helpers.identity : _ref23$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
    var response, _response12$data, _response12$data2, _response12;
    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.call)(_services.ValetService.changeValetFee, payload);
        case 3:
          response = _context12.sent;
          _context12.next = 6;
          return (0, _effects.put)({
            type: _variables2.CHANGE_VALET_FEE_SUCCESS,
            payload: response
          });
        case 6:
          _context12.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Valet Fee changed successfully'
            }
          });
        case 8:
          callback();
          _context12.next = 19;
          break;
        case 11:
          _context12.prev = 11;
          _context12.t0 = _context12["catch"](0);
          _response12 = _context12.t0.response;
          _context12.next = 16;
          return (0, _effects.put)({
            type: _variables2.CHANGE_VALET_FEE_FAIL,
            payload: _response12
          });
        case 16:
          _context12.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response12$data = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data !== void 0 ? _response12$data : {}),
              data: _response12
            }
          });
        case 18:
          (0, _utils.logErr)((_response12$data2 = _response12 === null || _response12 === void 0 ? void 0 : _response12.data) !== null && _response12$data2 !== void 0 ? _response12$data2 : {});
        case 19:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 11]]);
  })();
}
function currentPriceTableFee(_ref25) {
  var payload = _ref25.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
    var response, _response13$data, _response13$data2, _response13;
    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 3;
          return (0, _effects.call)(_services.ValetService.currentPriceTableFee, payload);
        case 3:
          response = _context13.sent;
          _context13.next = 6;
          return (0, _effects.put)({
            type: _variables2.CURRENT_PRICE_TABLE_FEE_SUCCESS,
            payload: response
          });
        case 6:
          _context13.next = 16;
          break;
        case 8:
          _context13.prev = 8;
          _context13.t0 = _context13["catch"](0);
          _response13 = _context13.t0.response;
          _context13.next = 13;
          return (0, _effects.put)({
            type: _variables2.CURRENT_PRICE_TABLE_FEE_FAIL,
            payload: _response13
          });
        case 13:
          _context13.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response13$data = _response13 === null || _response13 === void 0 ? void 0 : _response13.data) !== null && _response13$data !== void 0 ? _response13$data : {}),
              data: _response13
            }
          });
        case 15:
          (0, _utils.logErr)((_response13$data2 = _response13 === null || _response13 === void 0 ? void 0 : _response13.data) !== null && _response13$data2 !== void 0 ? _response13$data2 : {});
        case 16:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 8]]);
  })();
}
function getValetById(_ref27) {
  var payload = _ref27.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
    var response, _response14$data, _response14$data2, _response14;
    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return (0, _effects.call)(_services.ValetService.getValetById, payload);
        case 3:
          response = _context14.sent;
          _context14.next = 6;
          return (0, _effects.put)({
            type: _variables2.GET_VALET_SUCCESS,
            payload: response
          });
        case 6:
          _context14.next = 16;
          break;
        case 8:
          _context14.prev = 8;
          _context14.t0 = _context14["catch"](0);
          _response14 = _context14.t0.response;
          _context14.next = 13;
          return (0, _effects.put)({
            type: _variables2.GET_VALET_FAIL,
            payload: _response14
          });
        case 13:
          _context14.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response14$data = _response14 === null || _response14 === void 0 ? void 0 : _response14.data) !== null && _response14$data !== void 0 ? _response14$data : {}),
              data: _response14
            }
          });
        case 15:
          (0, _utils.logErr)((_response14$data2 = _response14 === null || _response14 === void 0 ? void 0 : _response14.data) !== null && _response14$data2 !== void 0 ? _response14$data2 : {});
        case 16:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 8]]);
  })();
}
function editValet(_ref29) {
  var payload = _ref29.payload,
    _ref29$callback = _ref29.callback,
    callback = _ref29$callback === void 0 ? _helpers.identity : _ref29$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
    var response, _response15$data, _response15$data2, _response15;
    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return (0, _effects.call)(_services.ValetService.getValetById, payload);
        case 3:
          response = _context15.sent;
          _context15.next = 6;
          return (0, _effects.put)({
            type: _variables2.EDIT_VALET_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context15.next = 17;
          break;
        case 9:
          _context15.prev = 9;
          _context15.t0 = _context15["catch"](0);
          _response15 = _context15.t0.response;
          _context15.next = 14;
          return (0, _effects.put)({
            type: _variables2.EDIT_VALET_FAIL,
            payload: _response15
          });
        case 14:
          _context15.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response15$data = _response15 === null || _response15 === void 0 ? void 0 : _response15.data) !== null && _response15$data !== void 0 ? _response15$data : {}),
              data: _response15
            }
          });
        case 16:
          (0, _utils.logErr)((_response15$data2 = _response15 === null || _response15 === void 0 ? void 0 : _response15.data) !== null && _response15$data2 !== void 0 ? _response15$data2 : {});
        case 17:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[0, 9]]);
  })();
}
function valetUsageByPeriods(_ref31) {
  var payload = _ref31.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
    var response, _response16$data, _response16$data2, _response16;
    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return (0, _effects.call)(_services.ValetService.valetUsageByPeriods, payload);
        case 3:
          response = _context16.sent;
          _context16.next = 6;
          return (0, _effects.put)({
            type: _variables2.VALET_USAGE_BY_PERIODS_SUCCESS,
            payload: response
          });
        case 6:
          _context16.next = 16;
          break;
        case 8:
          _context16.prev = 8;
          _context16.t0 = _context16["catch"](0);
          _response16 = _context16.t0.response;
          _context16.next = 13;
          return (0, _effects.put)({
            type: _variables2.VALET_USAGE_BY_PERIODS_FAIL,
            payload: _response16
          });
        case 13:
          _context16.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response16$data = _response16 === null || _response16 === void 0 ? void 0 : _response16.data) !== null && _response16$data !== void 0 ? _response16$data : {}),
              data: _response16
            }
          });
        case 15:
          (0, _utils.logErr)((_response16$data2 = _response16 === null || _response16 === void 0 ? void 0 : _response16.data) !== null && _response16$data2 !== void 0 ? _response16$data2 : {});
        case 16:
        case "end":
          return _context16.stop();
      }
    }, _callee16, null, [[0, 8]]);
  })();
}
function valetMovementByDay(_ref33) {
  var payload = _ref33.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee17() {
    var response, _response17$data, _response17$data2, _response17;
    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.prev = 0;
          _context17.next = 3;
          return (0, _effects.call)(_services.ValetService.valetMovementByDay, payload);
        case 3:
          response = _context17.sent;
          _context17.next = 6;
          return (0, _effects.put)({
            type: _variables2.VALET_MOVEMENT_BY_DAY_SUCCESS,
            payload: response
          });
        case 6:
          _context17.next = 16;
          break;
        case 8:
          _context17.prev = 8;
          _context17.t0 = _context17["catch"](0);
          _response17 = _context17.t0.response;
          _context17.next = 13;
          return (0, _effects.put)({
            type: _variables2.VALET_MOVEMENT_BY_DAY_FAIL,
            payload: _response17
          });
        case 13:
          _context17.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response17$data = _response17 === null || _response17 === void 0 ? void 0 : _response17.data) !== null && _response17$data !== void 0 ? _response17$data : {}),
              data: _response17
            }
          });
        case 15:
          (0, _utils.logErr)((_response17$data2 = _response17 === null || _response17 === void 0 ? void 0 : _response17.data) !== null && _response17$data2 !== void 0 ? _response17$data2 : {});
        case 16:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[0, 8]]);
  })();
}

// CREATE YOUR SAGAS HERE
function valetWatcher() {
  return _regenerator["default"].wrap(function valetWatcher$(_context18) {
    while (1) switch (_context18.prev = _context18.next) {
      case 0:
        _context18.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables2.LIST_VALETS_REQUEST, listValets), (0, _effects.takeLatest)(_variables2.LIST_PAST_VALETS_REQUEST, listPastValets), (0, _effects.takeLatest)(_variables2.GET_VALET_REQUEST, getValetById), (0, _effects.takeLatest)(_variables2.EDIT_VALET_REQUEST, editValet), (0, _effects.takeLatest)(_variables2.VALET_USAGE_BY_PERIODS_REQUEST, valetUsageByPeriods), (0, _effects.takeLatest)(_variables2.VALET_MOVEMENT_BY_DAY_REQUEST, valetMovementByDay), (0, _effects.takeLatest)(_variables2.VALET_CUSTOMERS_REPORT_REQUEST, listCustomersReport), (0, _effects.takeLatest)(_variables2.LIST_PAYMENT_METHOD_FILTERS_REQUEST, listPaymentMethodsFilters), (0, _effects.takeLatest)(_variables2.LIST_SORT_BY_FILTERS_REQUEST, listSortByFilters), (0, _effects.takeLatest)(_variables2.VALET_ABILITY_REQUEST, valetAbility), (0, _effects.takeLatest)(_variables2.CURRENT_VALET_FEE_REQUEST, currentValetFee), (0, _effects.takeLatest)(_variables2.VALET_ALLOW_CHECKOUT_REQUEST, valetAllowCheckout), (0, _effects.takeLatest)(_variables2.VALET_PAYMENT_SUMMARY_REQUEST, valetPaymentSummary), (0, _effects.takeLatest)(_variables2.EXPORT_CUSTOMERS_REPORT_PDF_REQUEST, exportCustomersReportPDF), (0, _effects.takeLatest)(_variables2.EXPORT_CUSTOMERS_REPORT_CSV_REQUEST, exportCustomersReportCSV), (0, _effects.takeLatest)(_variables2.CHANGE_VALET_FEE_REQUEST, changeValetFee), (0, _effects.takeLatest)(_variables2.CURRENT_PRICE_TABLE_FEE_REQUEST, currentPriceTableFee)]);
      case 2:
      case "end":
        return _context18.stop();
    }
  }, _marked);
}